export default __webpack_public_path__ + "static/media/food02.c38ba9e5.png";